import { Star, Quote, MapPin } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { TESTIMONIALS, REVIEWS_LINK } from "@/data/site";

export const Testimonials = () => (
  <section id="testimoni" data-testid="testimonials-section" className="surface py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <SectionHead
        overline="Testimoni Pelanggan"
        title={<>Kata Mereka yang <span className="italic accent-text">Sudah Order</span></>}
        sub="Ulasan asli pelanggan dari Google Maps, dipadukan foto kiriman nyata dari gudang kami — kepercayaan dibangun dari kayu yang datang sesuai janji."
      />
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <figure
              className="card-surface group flex h-full flex-col overflow-hidden rounded-[1.4rem] transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl"
              data-testid={`testimonial-card-${i + 1}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={t.photo}
                  alt={`Foto kiriman kayu untuk ${t.name}`}
                  loading="lazy"
                  className="h-44 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span
                  className="absolute left-4 top-4 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider"
                  style={{ background: "linear-gradient(90deg,#8B5CF6,#EF4444)", color: "#fff" }}
                >
                  Kiriman Nyata
                </span>
              </div>
              <blockquote className="flex flex-1 flex-col p-6">
                <div className="mb-3 flex items-center justify-between">
                  <span className="flex gap-0.5" style={{ color: "var(--t-accent)" }}>
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={15} fill="currentColor" strokeWidth={0} />
                    ))}
                  </span>
                  <Quote size={20} style={{ color: "color-mix(in srgb, var(--t-accent) 40%, transparent)" }} />
                </div>
                <p className="flex-1 text-sm leading-relaxed text-brand-muted">"{t.text}"</p>
                <figcaption className="mt-5 border-t pt-4" style={{ borderColor: "var(--t-border)" }}>
                  <p className="font-serif text-base font-semibold text-brand-ink">{t.name}</p>
                  <p className="text-xs text-brand-muted">{t.role}</p>
                </figcaption>
              </blockquote>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14">
        <div
          className="card-surface grain relative overflow-hidden rounded-[1.8rem] px-8 py-12 text-center"
          data-testid="review-cta"
        >
          <p className="overline-label mb-4">Nyonya & Tuan Pelanggan Kami</p>
          <h3 className="font-serif text-2xl font-semibold text-brand-ink sm:text-3xl">
            Berkenan Berbagi <span className="italic accent-text">Pengalaman Anda?</span>
          </h3>
          <div className="mt-5 flex justify-center gap-1.5" style={{ color: "var(--t-accent)" }}>
            {[...Array(5)].map((_, s) => (
              <Star key={s} size={30} fill="currentColor" strokeWidth={0} />
            ))}
          </div>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-brand-muted">
            Jika kayu dan pelayanan kami berkenan di hati Nyonya dan Tuan, satu ulasan bintang 5
            dari Anda sangat berarti bagi usaha kami — dan membantu pelanggan lain menemukan kayu
            berkualitas.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href={REVIEWS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="write-review-button"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-bold transition-transform duration-300 hover:-translate-y-0.5"
              style={{ background: "linear-gradient(90deg,#8B5CF6,#EF4444)", color: "#fff" }}
            >
              <Star size={16} fill="currentColor" strokeWidth={0} /> Tulis Ulasan Bintang 5
            </a>
            <a
              href={REVIEWS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-button"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-bold transition-transform duration-300 hover:-translate-y-0.5"
              style={{ backgroundColor: "var(--t-accent)", color: "var(--t-dark)" }}
            >
              <MapPin size={16} /> Lihat Semua Ulasan di Google Maps
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
